var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[(_vm.icon)?_c('g-card-icon',{attrs:{"value":_vm.icon}}):_vm._e(),_c('v-card-title',{attrs:{"data-name":"scl-title"}},[_c('h4',[_vm._v(_vm._s(_vm.title))])]),_c('v-divider'),_c('g-list',{attrs:{"value":_vm.items}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }